import { tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_ContextRule } from './types.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
import { Validator_SmartDocParmaResolver_VariableResolver } from '../../../smart-doc-param-resolver/index.js';
export const Validator_SmartDocStaticParam_ContextRule = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_ContextRule]),
    resolver: Validator_SmartDocParmaResolver_VariableResolver,
    id: tsValidateUniqueId,
};
//# sourceMappingURL=validator.js.map